<div>

  <br/>
  <br/>

  <!-- Download -->
  <div class="section-download">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="text-center">
            <h3>Download Croissant</h3>
            <br/>
          </div>
        </div>

        <div class="col text-end">
          <a href="https://itunes.apple.com/us/app/croissant-get-work-done-anywhere/id996707738?mt=8" target="_blank">
            <img src="/images/download/ios.svg" width="120" alt="Get it for iOS"/>
          </a>
          <br/>
        </div>
        <div class="col text-start">
          <a href="https://play.google.com/store/apps/details?id=com.croissant.ios" target="_blank">
            <img src="/images/download/android.svg" width="120" alt="Get it for Android"/>
          </a>
          <br/>
        </div>
      </div>
    </div>
  </div>

  <br/>
  <br/>
  <br/>

</div>
